import { render } from "./ModeratorDetail.vue?vue&type=template&id=70899c51"
import script from "./ModeratorDetail.vue?vue&type=script&lang=js"
export * from "./ModeratorDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__